import { formatCurrency, formatCurrencyWithDecimals } from "#lib/formatters"
import { useMemo } from "react"
import { useUserCurrency } from "./use-user-settings"

/**
 * Hook that provides currency-aware formatters using the user's currency preference
 */
export function useCurrencyFormatters() {
  const currency = useUserCurrency()

  return useMemo(
    () => ({
      formatCurrency: (amount: number | string | null | undefined) =>
        formatCurrency(amount, currency),
      formatCurrencyWithDecimals: (
        amount: number | string | null | undefined,
        minimumFractionDigits: number = 2,
        maximumFractionDigits: number = 2
      ) =>
        formatCurrencyWithDecimals(amount, minimumFractionDigits, maximumFractionDigits, currency),
      currency,
    }),
    [currency]
  )
}
